import { AxiosInstance, AxiosResponse } from "axios";
import qs from "qs";
import { ApiPath } from "src/api";
import { ApiResponse } from "../public-types";
import { FacilityUsageSlotListParams, FacilityUsageSlotSimple } from "./facility-usage-slot-types";

/**
 * RCL31. 공용공간 사용내역(정산) 페이징 리스트 조회
 * GET /api/ctrl/partners/{partnerId}/ct/contract/facility-usage-slots
 * 소진시간(사용 슬롯) 기준으로 공용공간 예약/정산 내역을 조회한다.
 */
export const getFacilityUsageSlotsAsync = (
  axios: AxiosInstance,
  params?: FacilityUsageSlotListParams,
): Promise<AxiosResponse<ApiResponse<{ content: FacilityUsageSlotSimple[] }>>> => {
  const path = ApiPath.contract.facilityUsageSlots;
  return axios.get<ApiResponse<{ content: FacilityUsageSlotSimple[] }>>(path, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params, { allowDots: true, encode: true }),
    },
  });
};
